/** @module utils/formatPhoneNumber */

/**
 * Formats a phone number
 * @param phoneNumber - The phone number to format
 * @return The formatted phone number e.g (123) 456-7890
 */
const formatPhoneNumber = (phoneNumber: string): string => {
    const cleanedNumber = (phoneNumber || '')
        .toString()
        .replace(/^\+?1/, '')
        .replace(/\D/g, '')
        .match(/^(\d{3})(\d{3})(\d{4})$/);

    return !cleanedNumber
        ? ''
        : `(${cleanedNumber[1]}) ${cleanedNumber[2]}-${cleanedNumber[3]}`;
};

export default formatPhoneNumber;
